import './index.css';
import './globals.css';

import React, { useLayoutEffect } from 'react';
import ReactDOM from 'react-dom/client';
import Price from '@/pages/misc/price/index.tsx';
import { ThemeProvider } from '@/contexts/themeContext.tsx';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Content />
  </React.StrictMode>
);

function clearPageSpinner() {
  const ele = document.getElementById('loading');
  if (ele) {
    ele.parentNode?.removeChild(ele);
  }
}

function Content() {
  useLayoutEffect(() => {
    clearPageSpinner();
  }, []);

  // need to set default theme to 'light'
  return (
    <ThemeProvider defaultTheme="light">
      <Price />
    </ThemeProvider>
  );
}
